import { Observable } from 'rxjs';

export interface IHttpCoreService<T> {
    getAll(endPoint: string);
    getByFilters(endPoint: string, filters: any);
    getById(endPoint: string, id: number): Observable<T>;
    get(endPoint: string): Observable<T>;
    post(endPoint: string, post: T): Observable<T>;
    put(endPoint: string, post: T): Observable<T>;
    delete(endPoint: string, item: T): Observable<T>;
    bulkPut(endPoint: string, post: any): Observable<T>;
    bulkDelete(endPoint: string, post: any): Observable<T>;
  }
